import { Component, inject } from '@angular/core';
import { AppService } from '@mavles/user';
import { StaticDataService } from '@mavles/shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private appService = inject(AppService);
  protected staticDataService = inject(StaticDataService);

  // reactive state
  user$ = this.appService.user$;
}


